import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "toggle-buttons",
  templateUrl: "./toggle-buttons.component.html",
})
export class ToggleButtonsComponent implements OnInit {

  @Input() public labelTrue: string = "true";
  @Input() public labelFalse: string = "false";
  @Input() public value: any = true;
  @Input() public reverse: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public toggleIcons: boolean = false;
  @Input() public iconsType: string = "toggle";
  @Input() public minimal: boolean = false;
  @Input() public hasError: boolean = false;
  @Input() public hasWarning: boolean = false;
  @Input() public size: 'xs' | 'sm' | 'md' | 'lg' = 'sm';

  @Output() public changed = new EventEmitter();

  public bool: boolean = true;

  public get sizeClass(): string {
    return this.size === 'md' ? 'btn-group' : `btn-group-${this.size}`;
  }

  public ngOnInit(): void {
    this.initValue();
  }

  public ngOnChanges(): void {
    this.initValue();
  }

  public initValue() {
    let val = this.value;
    if (val === "true") {
      val = true;
    }
    if (val === "false") {
      val = false;
    }
    this.bool = this.reverse ? !val : val;
  }

  public renderIcon() {
    if (this.toggleIcons && this.iconsType.length > 0) {
      switch (this.iconsType) {
        case "check":
          return `far ${this.bool ? "fa-square-check" : "fa-square"}`;
        default:
        case "toggle":
          return `fas ${this.bool ? "fa-toggle-large-on toggle-primary" : "fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled"}`;
      }
    }
  }

  public change() {
    this.changed.emit(this.reverse ? !this.bool : this.bool);
  }

}
